import React from "react";
import { useState } from "react";
import { FormattedMessage } from "react-intl";
import { formInputInfo } from "../../types/types";
import FormInput from "../form/FormInput";
import { FormSelect } from "../form/FormSelect";

interface HideModalProps {
  styles?: string;
  modalId: string;
  item: formInputInfo;
  options: { id: string; name: string }[];
  modalAction: (item: formInputInfo, modalId: string) => void;
  modalCancel: (modalId: string) => void;
}

export const HideModal: React.FC<HideModalProps> = ({
  styles,
  modalId,
  item,
  options,
  modalAction,
  modalCancel,
}) => {
  const [state, setState] = useState({
    ...item,
    hide: item.hide
      ? {
          key: findValue(item.hide.key),
          value: item.hide.value,
          type: item.hide.type,
        }
      : { key: "", value: "", type: "" },
  });
  const style = styles !== undefined ? styles : "text-center shadow-xl";

  const optionsName = [""].concat(
    options.map((item) => `${item.name}::${item.id}`)
  );
  const typeOptions = ["", "hide", "show"];

  const localInputChange = (e: any) => {
    setState({
      ...state,
      hide: {
        ...state.hide,
        [e.target.id]: e.target.value,
      },
    });
  };

  function findValue(key: string) {
    const item = options.find((item) => item.id === key);
    return item !== undefined ? `${item.name}::${item.id}` : "";
  }

  function findId(key: string) {
    const id = key.split("::")[1];
    const item = options.find((item) => item.id === id);
    return item !== undefined ? item.id : "";
  }

  //TODO: intenationalisaatiot/käännökset input kenttien question attribuuteille!

  return (
    <div className={style}>
      <div className='flex flex-col'>
        <div className='flex flex-col'>
          <p className='uppercase font-semibold m-4 text-brand-dark_blue'>
            Piilotetaanko kysymys?
          </p>
          <p className='m-4 text-brand-dark_blue'>
            Kysymys voidaan piilottaa ehdollisesti.
          </p>
          <FormSelect
            id='type'
            question='type'
            options={typeOptions}
            value={state.hide.type}
            handleInputChange={localInputChange}
            cursiveLabel={`Kysymys joko 'hide' (piilotetaan) tai 'show' (näytetään) ehtojen täyttyessä`}
          />
          <FormSelect
            id='key'
            question='key'
            options={optionsName}
            value={state.hide.key}
            handleInputChange={localInputChange}
            cursiveLabel='Valitse kysymys, jonka perusteella piilotetaan {(kysymys):(id)}'
          />
          <FormInput
            id='value'
            question='value'
            value={state.hide.value}
            type='text'
            handleInputChange={localInputChange}
            cursiveLabel='Syötä arvo, jonka perusteella kysymys piilotetaan'
          />
        </div>
        <div className='flex flex-row justify-around'>
          <div className='pb-6'>
            <button
              onClick={() =>
                modalAction(
                  {
                    ...state,
                    hide: {
                      key: findId(state.hide.key),
                      value: state.hide.value,
                      type: state.hide.type,
                    },
                  },
                  modalId
                )
              }
              className='bg-brand-white hover:bg-blue-200 text-brand-blue m-4 rounded w-20 h-10'
            >
              <FormattedMessage id='AlertDialog.confirm_button' />
            </button>
          </div>
          <div className='pb-6'>
            <button
              onClick={() =>
                modalAction(
                  {
                    ...state,
                    hide: {
                      key: "",
                      value: "",
                      type: "",
                    },
                  },
                  modalId
                )
              }
              className='bg-red-300 hover:bg-red-400 text-brand-white m-4 rounded w-20 h-10'
            >
              Poista piilotus
            </button>
          </div>
          <div className='pb-6'>
            <button
              onClick={() => modalCancel(modalId)}
              className='bg-brand-white hover:bg-blue-200 text-brand-blue m-4 rounded w-20 h-10'
            >
              <FormattedMessage id='AlertDialog.cancel_button' />
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default HideModal;
